"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module parjs/internal/implementation/parsers
 */
/** */
const action_1 = require("../../action");
const reply_1 = require("../../../../reply");
const issues_1 = require("../../issues");
/**
 * Created by lifeg on 24/11/2016.
 */
class PrsFail extends action_1.ParjsBasicAction {
    constructor(_kind, expecting) {
        super();
        this._kind = _kind;
        this.expecting = expecting;
        [reply_1.ReplyKind.Ok, reply_1.ReplyKind.Unknown].indexOf(_kind) >= 0 && issues_1.Issues.expectedFailureKind("fail");
    }
    _apply(ps) {
        ps.kind = this._kind;
        ps.expecting = this.expecting;
    }
}
exports.PrsFail = PrsFail;
//# sourceMappingURL=fail.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/parjs/internal/implementation/parsers/primitives/fail.js
// module id = 1001
// module chunks = 0 1